var v = Object.defineProperty;
var M = (n, t, e) => t in n ? v(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var r = (n, t, e) => M(n, typeof t != "symbol" ? t + "" : t, e);
import { useQuery as b, useInfiniteQuery as T } from "@tanstack/react-query";
import { useAuth as k } from "../context/auth/index.js";
import { useSchool as Q } from "../context/school/index.js";
class U {
  constructor(t, e, o, s, i) {
    r(this, "props");
    r(this, "url");
    r(this, "config");
    r(this, "key");
    r(this, "queryOptions");
    this.props = e, this.url = o, this.config = s, this.key = t, this.queryOptions = i;
  }
  ToQuery({ enabled: t } = {}) {
    var i, u, h, y, p, a, l, c, q, O, f, m, g, d, I, P;
    const { Get: e, Post: o } = k(), { baseUrl: s } = Q();
    return this.props && ("data" in this.props || "method" in this.props && this.props.method == "POST") ? b({
      queryKey: this.key,
      queryFn: () => o({
        url: s + this.url,
        data: this.props && "data" in this.props ? this.props.data : null,
        config: this.config
      }),
      retry: (i = this.queryOptions) != null && i.retry ? (u = this.queryOptions) == null ? void 0 : u.retry : !1,
      staleTime: (h = this.queryOptions) != null && h.stale ? (y = this.queryOptions) == null ? void 0 : y.stale : 0,
      select: (p = this.queryOptions) == null ? void 0 : p.select,
      enabled: t ?? ((a = this.queryOptions) == null ? void 0 : a.enabled),
      refetchInterval: (l = this.queryOptions) == null ? void 0 : l.refetchInterval,
      refetchOnMount: (c = this.queryOptions) == null ? void 0 : c.refetchOnMount
    }) : b({
      queryKey: this.key,
      queryFn: () => e({
        url: s + this.url,
        data: null,
        config: this.config
      }),
      retry: (q = this.queryOptions) != null && q.retry ? (O = this.queryOptions) == null ? void 0 : O.retry : !1,
      staleTime: (f = this.queryOptions) != null && f.stale ? (m = this.queryOptions) == null ? void 0 : m.stale : 0,
      select: (g = this.queryOptions) == null ? void 0 : g.select,
      enabled: t ?? ((d = this.queryOptions) == null ? void 0 : d.enabled),
      refetchInterval: (I = this.queryOptions) == null ? void 0 : I.refetchInterval,
      refetchOnMount: (P = this.queryOptions) == null ? void 0 : P.refetchOnMount
    });
  }
}
class D {
  constructor(t, e, o, s, i) {
    r(this, "props");
    r(this, "url");
    r(this, "config");
    r(this, "key");
    r(this, "queryOptions");
    this.props = e, this.url = o, this.config = s, this.key = t, this.queryOptions = i;
  }
  ToQuery({ enabled: t } = {}) {
    var s, i, u, h, y, p, a, l, c;
    const { Get: e } = k(), { baseUrl: o } = Q();
    return T({
      queryKey: this.key,
      queryFn: async ({ pageParam: q }) => {
        var O;
        return e({
          url: `${o}${(O = this.queryOptions) == null ? void 0 : O.infiniteQueryUrl(q)}`,
          data: null,
          config: this.config
        });
      },
      initialPageParam: 1,
      getNextPageParam: (s = this.queryOptions) == null ? void 0 : s.getNextPageParam,
      retry: (i = this.queryOptions) != null && i.retry ? (u = this.queryOptions) == null ? void 0 : u.retry : !1,
      staleTime: (h = this.queryOptions) != null && h.stale ? (y = this.queryOptions) == null ? void 0 : y.stale : 0,
      select: (p = this.queryOptions) == null ? void 0 : p.infiniteSelect,
      enabled: t ?? ((a = this.queryOptions) == null ? void 0 : a.enabled),
      refetchInterval: (l = this.queryOptions) == null ? void 0 : l.refetchInterval,
      refetchOnMount: (c = this.queryOptions) == null ? void 0 : c.refetchOnMount
    });
  }
}
export {
  D as DaymapInfiniteQuery,
  U as DaymapQuery
};
//# sourceMappingURL=daymapQuery.js.map
